import { useEffect, useState } from 'react';
import { AppModal, AppRemixIcon, AppNoInfo } from '@/layout/AppComponents';
import styled from 'styled-components';
import { Scrollbars } from 'react-custom-scrollbars';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactDOMServer from 'react-dom/server';
import { axiosPath } from '../../../../../../routing/helpers/router';
import colors from '../../../../../../constants/colors';
import minions from '../../../../../../minions/minions';
import * as currentPageAction from '../../../../../../store/actions/currentPageAction';
import EvidenceNewForm from './Evidence/EvidenceNewForm';
import EvidenceEditForm from './Evidence/EvidenceEditForm';
import NotificationAlert from '../../../../../components/helpers/notificationAlert';
import Translator from '../../../../../components/helpers/Translator';
import errorHandler from '@/layout/components/error/ErrorHandler';
import _ from 'lodash';

const EvidenceTab = (props) => {
  const { plantObligationID } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();
  const userId = useSelector((s) => s?.auth?.user?.id);
  const permissions = useSelector((s) => s.module[moduleBridgeHex].permissions);
  const evidencesPermissions = useSelector(
    (s) =>
      s.module?.[moduleBridgeHex]?.permissions?.gcl?.module?.plant?.evidences
  );
  const userBridgeSettings = useSelector(
    (s) => s.module?.[moduleBridgeHex]?.userBridge?.permissions
  );
  const evidences = useSelector(
    (s) => s.currentPage?.evidenceTabs?.[plantObligationID]
  );
  const poLevel3 = useSelector(
    (s) => s.currentPage?.plantObligationLevels?.level3
  );
  const [showAddNewEvidence, setShowAddNewEvidence] = useState(false);
  const [selectedEvidence, setSelectedEvidence] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [removedHistory, setRemovedHistory] = useState();
  const [showHistoricalModal, setShowHistoricalModal] = useState(false);

  const isEditingForbidden = () =>
    (userBridgeSettings?.level === 2 &&
      !userBridgeSettings?.evidences?.write) ||
    poLevel3?.[plantObligationID]?.alerts?.corporateObligation ||
    (userId !== selectedEvidence.userId &&
      evidencesPermissions?.editOnlyByUser &&
      evidencesPermissions?.editOnlyByUser !== false &&
      (!evidencesPermissions?.editOnlyByUser?.editOnlyByUserExceptions?.users ||
        !evidencesPermissions?.editOnlyByUser?.editOnlyByUserExceptions?.users.includes(
          userId
        )));

  // > LOAD EVIDENCE TAB
  const loadEvidenceTab = async () => {
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_legalCompliance_evidences_tab"),
        {
          moduleBridgeHex,
          plantHex,
          plantObligationID,
        }
      );
      return response.data;
    } catch (err) {}
  };
  useEffect(() => {
    loadEvidenceTab().then((r) => {
      dispatch(
        currentPageAction.change("evidenceTabs", { [plantObligationID]: r })
      );
    });
  }, []);
  // < LOAD EVIDENCE TAB

  const handleDownloadFile = async (url = null) => {
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_legalCompliance_evidences_download"),
        {
          evidenceID: selectedEvidence.id,
          plantHex,
          url,
        }
      );
      window.open(response.data, "_blank");
      return response.data;
    } catch (err) {}
  };

  // < ADD EVIDENCE
  const handleAddEvidence = async (values) => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_legalCompliance_evidences_upload"),
        minions.forms.toFormData({
          ...values,
          plantHex,
          plantObligationID,
          moduleBridgeHex,
        }),
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      dispatch(
        currentPageAction.change("evidenceTabs", {
          [plantObligationID]: response.data.evidenceTabs,
        })
      );
      if (permissions?.gcl?.module?.plant?.states?.needEvidenceToFulfilled) {
        const updatedLevel3 = { ...poLevel3 };
        updatedLevel3[plantObligationID].alerts.hasEvidences =
          response.data.hasEvidences;

        if (
          permissions?.gcl?.module?.plant?.states?.needEvidenceToFulfilled
            ?.needFile
        ) {
          updatedLevel3[plantObligationID].alerts.hasEvidencesWithFiles =
            response.data.hasEvidencesWithFiles;
        }

        dispatch(
          currentPageAction.change("plantObligationLevels", {
            level3: updatedLevel3,
          })
        );
      }
      setShowAddNewEvidence(false);
      setIsLoading(false);
      return response.data;
    } catch (err) {
      setIsLoading(false);
      dispatch(errorHandler(err));
    }
  };
  // < ADD EVIDENCE

  // < EDIT EVIDENCE
  const handleEditEvidence = async (values) => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_legalCompliance_evidences_edit"),
        minions.forms.toFormData({
          ...values,
          plantHex,
          plantObligationID,
          evidenceID: selectedEvidence.id,
          moduleBridgeHex,
        }),
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      dispatch(
        currentPageAction.change("evidenceTabs", {
          [plantObligationID]: response.data.evidenceTabs,
        })
      );
      if (permissions?.gcl?.module?.plant?.states?.needEvidenceToFulfilled) {
        const updatedLevel3 = { ...poLevel3 };
        updatedLevel3[plantObligationID].alerts.hasEvidences =
          response.data.hasEvidences;

        if (
          permissions?.gcl?.module?.plant?.states?.needEvidenceToFulfilled
            ?.needFile
        ) {
          updatedLevel3[plantObligationID].alerts.hasEvidencesWithFiles =
            response.data.hasEvidencesWithFiles;
        }

        dispatch(
          currentPageAction.change("plantObligationLevels", {
            level3: updatedLevel3,
          })
        );
      }
      setSelectedEvidence(undefined);
      // setSelectedEvidence(
      //   response.data.find((e) => e.id === selectedEvidence.id)
      // );
      setIsEditMode(false);
      setIsLoading(false);
      return response.data;
    } catch (err) {
      setIsLoading(false);
      dispatch(errorHandler(err));
    }
  };
  // < EDIT EVIDENCE

  // > REMOVE EVIDENCE
  const handleRemove = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_legalCompliance_evidences_remove"),
        {
          moduleBridgeHex,
          plantHex,
          evidenceID: selectedEvidence.id,
        }
      );
      dispatch(
        currentPageAction.change("evidenceTabs", {
          [plantObligationID]: evidences.filter(
            (e) => e.id !== selectedEvidence.id
          ),
        })
      );
      if (permissions?.gcl?.module?.plant?.states?.needEvidenceToFulfilled) {
        const updatedLevel3 = { ...poLevel3 };
        updatedLevel3[plantObligationID].alerts.hasEvidences =
          response.data.hasEvidences;

        if (
          permissions?.gcl?.module?.plant?.states?.needEvidenceToFulfilled
            ?.needFile
        ) {
          updatedLevel3[plantObligationID].alerts.hasEvidencesWithFiles =
            response.data.hasEvidencesWithFiles;
        }

        dispatch(
          currentPageAction.change("plantObligationLevels", {
            level3: updatedLevel3,
          })
        );
      }
      setSelectedEvidence(false);
      setIsEditMode(false);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      NotificationAlert({
        title: ReactDOMServer.renderToString(
          <Translator file="user" name="user.error" />
        ),
        message: ReactDOMServer.renderToString(
          <Translator
            file="module-legalCompliance"
            name="error.evidence.delete"
          />
        ),
        type: "danger",
        position: "top-center",
        duration: 0,
      });
    }
  };
  // < REMOVE EVIDENCE

  // < REMOVED HISTORY
  const handleRemovedHistory = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_legalCompliance_evidences_removedHistory"),
        { moduleBridgeHex, plantHex, plantObligationID }
      );
      setRemovedHistory(response.data);
      setIsLoading(false);
      return response.data;
    } catch (err) {
      setIsLoading(false);
    }
  };
  // < REMOVED HISTORY

  if (!evidences) return <AppNoInfo minHeight={300} />;

  return (
    <EvidenceTabContainer>
      <SidebarMenu>
        <>
          {(userBridgeSettings?.level !== 2 ||
            userBridgeSettings?.evidences?.write === true) &&
            !poLevel3?.[plantObligationID]?.alerts?.corporateObligation && (
              <span
                className="add-button"
                onClick={() => {
                  setShowAddNewEvidence(true);
                  setSelectedEvidence(false);
                  setIsEditMode(false);
                }}
              >
                <Translator
                  file="module-legalCompliance"
                  name="module.lc.new-evidence"
                />
              </span>
            )}
          {evidences.length > 0 ? (
            <Scrollbars style={{ height: '365px' }}>
              <ul>
                {evidences.map((evidence) => (
                  <li
                    key={evidence.id}
                    className={
                      selectedEvidence && selectedEvidence.id === evidence.id
                        ? 'ev-selected'
                        : ''
                    }
                    onClick={() => {
                      setShowAddNewEvidence(false);
                      setSelectedEvidence(evidence);
                      setIsEditMode(false);
                    }}
                  >
                    <div className="first-row">
                      <span
                        className="name"
                        title={evidence.name || evidence.description}
                      >
                        {evidence.name || evidence.description}
                      </span>
                      <AppRemixIcon
                        className="mr-2"
                        icon="attachment-2"
                        noVariants
                        color={
                          evidence.url || evidence?.urls?.length > 0
                            ? colors.primary
                            : colors.grey400
                        }
                      />
                    </div>
                    <div className="second-row">
                      <span className="sr-date">{evidence.date}</span>
                      {permissions.gcl?.module?.plant?.evidences
                        ?.showUserName && (
                        <span className="sr-user mr-2">{evidence.user}</span>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </Scrollbars>
          ) : (
            <AppNoInfo
              text={
                <Translator file="module-legalCompliance" name="no.evidences" />
              }
              color={colors.primaryLight}
              icon={
                <AppRemixIcon
                  size={24}
                  icon="file-search"
                  color={colors.primaryLight}
                />
              }
            />
          )}
        </>
      </SidebarMenu>
      <Content>
        {showAddNewEvidence ? (
          <EvidenceNewForm
            handleAddEvidence={handleAddEvidence}
            isLoading={isLoading}
          />
        ) : (
          <>
            {selectedEvidence ? (
              <>
                {isEditMode ? (
                  <EvidenceEditForm
                    selectedEvidence={selectedEvidence}
                    handleEditEvidence={handleEditEvidence}
                    onCancel={() => {
                      setSelectedEvidence(null);
                      setIsEditMode(false);
                    }}
                    onRemove={handleRemove}
                    isLoading={isLoading}
                  />
                ) : (
                  <>
                    <h3>
                      <Translator
                        file="module-legalCompliance"
                        name="evidence.information.name"
                        variables={{ name: selectedEvidence.name }}
                      />
                      <span
                        className="float-right pointer mr-2"
                        title={ReactDOMServer.renderToString(
                          <Translator
                            file="module-legalCompliance"
                            name="close"
                          />
                        )}
                      >
                        <AppRemixIcon
                          icon="close"
                          size={16}
                          onClick={() => {
                            setSelectedEvidence(null);
                            setIsEditMode(false);
                          }}
                        />
                      </span>
                      {isEditingForbidden() ? (
                        ''
                      ) : (
                        <span
                          className="float-right pointer mr-2"
                          title={ReactDOMServer.renderToString(
                            <Translator file="general" name="general.edit" />
                          )}
                        >
                          <AppRemixIcon
                            icon="edit"
                            className="float-right pointer mr-2"
                            size={16}
                            onClick={() => setIsEditMode(true)}
                          />
                        </span>
                      )}
                      {evidencesPermissions?.showUserName && (
                        <span
                          className={`float-right mr-2${
                            selectedEvidence &&
                            selectedEvidence.changeLogs.length > 0
                              ? ' pointer'
                              : ''
                          }`}
                          title={ReactDOMServer.renderToString(
                            <Translator
                              file="module-legalCompliance"
                              name="historical.state"
                            />
                          )}
                          onClick={() =>
                            selectedEvidence &&
                            selectedEvidence.changeLogs.length > 0
                              ? setShowHistoricalModal(true)
                              : undefined
                          }
                        >
                          <AppRemixIcon
                            icon="history"
                            size={16}
                            color={
                              selectedEvidence &&
                              selectedEvidence.changeLogs.length > 0
                                ? null
                                : colors.grey300
                            }
                          />
                        </span>
                      )}
                    </h3>
                    <EvidenceInfo className="mt-4">
                      <li>
                        <span className="eventinfo-title">
                          <Translator
                            file="module-legalCompliance"
                            name="name"
                          />
                        </span>
                        <span className="eventinfo-content">
                          {selectedEvidence.name}
                        </span>
                      </li>
                      <li>
                        <span className="eventinfo-title">
                          <Translator
                            file="module-legalCompliance"
                            name="associated.files"
                          />
                        </span>
                        <span className="eventinfo-content">
                          {selectedEvidence.urls &&
                          selectedEvidence.urls.length > 0 ? (
                            selectedEvidence.urls.map((url) => (
                              <FileDownload
                                key={url}
                                onClick={() => handleDownloadFile(url)}
                                title={ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-legalCompliance"
                                    name="download.file"
                                  />
                                )}
                              >
                                {minions.files.fileIcon(
                                  url,
                                  true,
                                  null,
                                  'mr-2'
                                )}
                                {url}
                              </FileDownload>
                            ))
                          ) : (
                            <span>
                              <Translator
                                file="module-legalCompliance"
                                name="no.associated.files"
                              />
                            </span>
                          )}
                        </span>
                      </li>
                      <li>
                        <span className="eventinfo-title">
                          <Translator
                            file="user"
                            name="user.obligation.evidence.date"
                          />
                        </span>
                        <span className="eventinfo-content">
                          {selectedEvidence.date ? (
                            selectedEvidence.date
                          ) : (
                            <span className="text-muted">
                              <Translator file="user" name="user.no-date" />
                            </span>
                          )}
                        </span>
                      </li>
                      <li>
                        <span className="eventinfo-title">
                          <Translator
                            file="module-legalCompliance"
                            name="module.lc.evidence.description"
                          />
                        </span>
                        <span
                          className="eventinfo-content"
                          style={{ maxWidth: 'calc(100vw - 900px)' }}
                        >
                          {selectedEvidence.description}
                        </span>
                      </li>
                    </EvidenceInfo>
                    {evidencesPermissions?.showUserName && (
                      <AppModal
                        title={ReactDOMServer.renderToString(
                          <Translator
                            file="module-legalCompliance"
                            name="historical.state"
                          />
                        )}
                        show={showHistoricalModal}
                        onClose={() => setShowHistoricalModal(false)}
                      >
                        <Scrollbars style={{ height: '380px' }}>
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th scope="col">
                                  <Translator
                                    file="module-legalCompliance"
                                    name="date"
                                  />
                                </th>
                                <th scope="col">
                                  <Translator
                                    file="general"
                                    name="general.user"
                                  />
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {selectedEvidence &&
                                selectedEvidence.changeLogs.map((cl) => (
                                  <tr key={cl.id}>
                                    <td>{cl.dateStamp}</td>
                                    <td title={cl.username || ''}>{cl.user}</td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </Scrollbars>
                      </AppModal>
                    )}
                  </>
                )}
              </>
            ) : (
              <AppNoInfo
                text={
                  <>
                    <span>
                      <Translator
                        file="module-legalCompliance"
                        name="select.evidence.or.create.button"
                      />
                      <b>
                        {' '}
                        <Translator
                          file="module-legalCompliance"
                          name="module.lc.new-evidence"
                        />
                      </b>
                      .
                    </span>
                    <br />
                    {evidencesPermissions?.showUserName && (
                      <>
                        <span
                          className="btn btn-sm btn-outline-primary mt-4"
                          onClick={() => handleRemovedHistory()}
                        >
                          <AppRemixIcon
                            icon="history"
                            className="pointer mr-2"
                            size={16}
                          />
                          <Translator
                            file="module-legalCompliance"
                            name="historical.evidence.delete"
                          />
                        </span>
                        <AppModal
                          title={ReactDOMServer.renderToString(
                            <Translator
                              file="module-legalCompliance"
                              name="historical.evidence.delete"
                            />
                          )}
                          show={removedHistory !== undefined}
                          onClose={() => setRemovedHistory(undefined)}
                        >
                          {_.isEmpty(removedHistory) ? (
                            <div className="alert alert-light">
                              <Translator
                                file="module-legalCompliance"
                                name="historical.evidence.delete.empty"
                              />
                            </div>
                          ) : (
                            <Scrollbars style={{ height: '380px' }}>
                              <table className="table table-hover">
                                <thead>
                                  <tr>
                                    <th scope="col">
                                      <Translator
                                        file="module-legalCompliance"
                                        name="date"
                                      />
                                    </th>
                                    <th scope="col">
                                      <Translator
                                        file="general"
                                        name="general.user"
                                      />
                                    </th>
                                    <th scope="col">
                                      <Translator
                                        file="module-legalCompliance"
                                        name="name"
                                      />
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {removedHistory &&
                                    removedHistory.map((cl) => (
                                      <tr key={cl.id}>
                                        <td>{cl.dateStamp}</td>
                                        <td title={cl.username || ''}>
                                          {cl.user}
                                        </td>
                                        <td>{cl.name}</td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </Scrollbars>
                          )}
                        </AppModal>
                      </>
                    )}
                  </>
                }
                color={colors.primaryLight}
                icon={
                  <AppRemixIcon
                    size={40}
                    icon="file-search"
                    color={colors.primaryLight}
                  />
                }
              />
            )}
          </>
        )}
      </Content>
    </EvidenceTabContainer>
  );
};
export default EvidenceTab;

const EvidenceTabContainer = styled.div`
  height: 400px;
  display: grid;
  grid-template-columns: 350px 1fr;
`;

const SidebarMenu = styled.div`
  overflow-y: auto;
  padding: 0;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .add-button {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid ${colors.primary};
    color: ${colors.primary};
    margin: 0;
    height: 32px;
    cursor: pointer;
  }
  ul {
    padding: 4px;
    //height: 268px;
    overflow-y: auto;
    li {
      padding: 4px 2px;
      border-bottom: 1px solid ${colors.grey300};
      cursor: pointer;
      &.ev-selected {
        background: ${colors.grey300};
      }
      .first-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: ${colors.primary};
        .name {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .second-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 10px;
        .sr-date {
          letter-spacing: 1px;
        }
        .sr-user {
          color: ${colors.primary};
        }
      }
    }
  }
`;

const Content = styled.div`
  border-left: 1px solid ${colors.grey300};
  padding: 4px;
  height: 400px;
  .row-no-margin > .row {
    margin: 0;
  }
`;
const EvidenceFileList = styled.ul`
  list-style: none;
  margin: 0;
  padding-left: 6px;
  li {
    cursor: pointer;
    display: flex;
    align-items: center;
    border-top: 1px solid ${colors.grey300};
    padding: 8px 0;
    span {
      font-size: 12px;
      color: ${colors.primary};
    }
  }
  li:first-child {
    border-top: 0;
  }
`;

const NoFilesCard = styled.div`
  border: 1px solid ${colors.grey300};
`;

const EvidenceInfo = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  height: 350px;
  overflow: auto;
  li {
    padding: 8px 0;
    border-top: 1px solid ${colors.grey300};
    display: flex;
    align-items: baseline;
    .eventinfo-title {
      display: inline-block;
      width: 200px;
      text-transform: uppercase;
      font-weight: bold;
      color: ${colors.primary};
    }
  }
`;

const FileDownload = styled.div`
  &:hover {
    cursor: pointer;
  }
`;
